"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.combineWithInput = combineWithInput;
/**
 * Util method which combines the input with the output
 * Especially useful when you need to combine observables
 * e.g. switchMap(input => observableFn(input).pipe(map(combineWithInput(input)))
 * passes back: [input, output]
 * @param input
 * @deprecated use combineWithInput from @engineering11/stream-utility
 * @returns a function returning a typed array of [input, output]
 */
function combineWithInput(input) {
    return (output) => [input, output];
}
